<div class="container">
    <img src="../../../../assets/icons/warning-icon-white.svg" alt="">
    <h1 class="text">{{ warningText }}</h1>
</div>
